(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[147],{

/***/ 64684:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(96116);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');
module.exports = asciiSize;

/***/ }),

/***/ 378:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}
module.exports = asciiToArray;

/***/ }),

/***/ 78461:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(27117),
  isObjectLike = __webpack_require__(32195);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}
module.exports = baseIsRegExp;

/***/ }),

/***/ 95224:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
    length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}
module.exports = baseSlice;

/***/ }),

/***/ 40454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(95224);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return !start && end >= length ? array : baseSlice(array, start, end);
}
module.exports = castSlice;

/***/ }),

/***/ 42589:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
  rsComboMarksRange = '\\u0300-\\u036f',
  reComboHalfMarksRange = '\\ufe20-\\ufe2f',
  rsComboSymbolsRange = '\\u20d0-\\u20ff',
  rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
  rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}
module.exports = hasUnicode;

/***/ }),

/***/ 40731:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiSize = __webpack_require__(64684),
  hasUnicode = __webpack_require__(42589),
  unicodeSize = __webpack_require__(91082);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
}
module.exports = stringSize;

/***/ }),

/***/ 79993:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(378),
  hasUnicode = __webpack_require__(42589),
  unicodeToArray = __webpack_require__(20424);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
module.exports = stringToArray;

/***/ }),

/***/ 91082:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
  rsComboMarksRange = '\\u0300-\\u036f',
  reComboHalfMarksRange = '\\ufe20-\\ufe2f',
  rsComboSymbolsRange = '\\u20d0-\\u20ff',
  rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
  rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
  rsCombo = '[' + rsComboRange + ']',
  rsFitz = '\\ud83c[\\udffb-\\udfff]',
  rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
  rsNonAstral = '[^' + rsAstralRange + ']',
  rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
  rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
  rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
  rsOptVar = '[' + rsVarRange + ']?',
  rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
  rsSeq = rsOptVar + reOptMod + rsOptJoin,
  rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}
module.exports = unicodeSize;

/***/ }),

/***/ 20424:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
  rsComboMarksRange = '\\u0300-\\u036f',
  reComboHalfMarksRange = '\\ufe20-\\ufe2f',
  rsComboSymbolsRange = '\\u20d0-\\u20ff',
  rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
  rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
  rsCombo = '[' + rsComboRange + ']',
  rsFitz = '\\ud83c[\\udffb-\\udfff]',
  rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
  rsNonAstral = '[^' + rsAstralRange + ']',
  rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
  rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
  rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
  rsOptVar = '[' + rsVarRange + ']?',
  rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
  rsSeq = rsOptVar + reOptMod + rsOptJoin,
  rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}
module.exports = unicodeToArray;

/***/ }),

/***/ 96575:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(78461),
  baseUnary = __webpack_require__(8345),
  nodeUtil = __webpack_require__(73651);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
module.exports = isRegExp;

/***/ }),

/***/ 24837:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(1375);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
  MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
module.exports = toFinite;

/***/ }),

/***/ 93878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(24837);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
    remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

/***/ }),

/***/ 52634:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(33734),
  castSlice = __webpack_require__(40454),
  hasUnicode = __webpack_require__(42589),
  isObject = __webpack_require__(23831),
  isRegExp = __webpack_require__(96575),
  stringSize = __webpack_require__(40731),
  stringToArray = __webpack_require__(79993),
  toInteger = __webpack_require__(93878),
  toString = __webpack_require__(41991);

/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
  DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
    omission = DEFAULT_TRUNC_OMISSION;
  if (isObject(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? toInteger(options.length) : length;
    omission = 'omission' in options ? baseToString(options.omission) : omission;
  }
  string = toString(string);
  var strLength = string.length;
  if (hasUnicode(string)) {
    var strSymbols = stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += result.length - end;
  }
  if (isRegExp(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
        substring = result;
      if (!separator.global) {
        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while (match = separator.exec(substring)) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(baseToString(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}
module.exports = truncate;

/***/ }),

/***/ 37296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(24782);

/***/ }),

/***/ 76468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y9": function() { return /* binding */ PageScreenshot; },
  "IM": function() { return /* binding */ PageScreenshotWrapper; },
  "t9": function() { return /* binding */ StyledScreenshotImg; }
});

// UNUSED EXPORTS: COMPUTED_SCREENSHOT_ASPECT_RATIO

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(86524);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.ts + 2 modules
var Icons = __webpack_require__(51950);
// EXTERNAL MODULE: ./src/components/UI/Tooltip/index.ts + 60 modules
var Tooltip = __webpack_require__(23732);
;// CONCATENATED MODULE: ./src/components/Shared/PageThumbnail/SourceIcon.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 12px;\n  right: 8px;\n  color: inherit;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var SourceIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSourceIcon, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
            tooltipText: "Origin",
            delayShow: 500,
            children: "[*]"
        })
    });
};
var StyledSourceIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ee00ceb-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/Shared/PageThumbnail/PageScreenshot.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function PageScreenshot_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    PageScreenshot_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  aspect-ratio: ",
        "; // ensures the image is rendered the same size even before load completes\n  object-fit: contain;\n  position: relative;\n  border: ",
        ";\n  transition-duration: all 0.2s ease;\n  background-color: ",
        ";\n  &:hover {\n    border-color: ",
        ";\n  }\n  &:active {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: default;\n  width: 150px;\n  aspect-ratio: ",
        ";\n  position: relative;\n  border: ",
        ";\n  color: ",
        ";\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var COMPUTED_SCREENSHOT_ASPECT_RATIO = 120 / 205.41; // from looking at how the images are actually rendered
var PageScreenshot = function(param) {
    var plate = param.plate, handleClick = param.handleClick, styles = param.styles, locked = param.locked, isSourcePage = param.isSourcePage, useBigImage = param.useBigImage;
    var ref;
    var theme = (0,es/* useSelector */.v9)(function(state) {
        return state.globalUI.uiSettings.theme;
    });
    var isPublic = plate.observe(function(state) {
        return state.isPublic;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageScreenshotWrapper, {
        children: [
            !locked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledScreenshotImg, {
                isPublic: isPublic,
                onClick: handleClick,
                style: styles,
                plateTitle: plate.snapshot.title,
                src: plate.getThumbnailUrl({
                    size: useBigImage ? "big" : "small",
                    theme: theme
                }),
                draggable: false
            }, ((ref = plate.snapshot.screenshotTime) === null || ref === void 0 ? void 0 : ref.toString()) || plate.snapshot.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLockedPage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Locked */.QM, {})
            }),
            isSourcePage && /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceIcon, {})
        ]
    });
};
var PageScreenshotWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-78185ddd-0"
})(PageScreenshot_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.subtle;
});
var StyledScreenshotImg = styled_components_browser_esm/* default.img.attrs */.ZP.img.attrs(function(props) {
    return {
        "data-testid": "page-screenshot-".concat(props.plateTitle)
    };
}).withConfig({
    componentId: "sc-78185ddd-1"
})(_templateObject1(), COMPUTED_SCREENSHOT_ASPECT_RATIO, function(param) {
    var theme = param.theme, isPublic = param.isPublic;
    return isPublic ? "2px solid ".concat(theme.primary) : "2px solid ".concat(theme.accent);
}, function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var theme = param.theme;
    return theme.text.subtle;
}, function(param) {
    var theme = param.theme;
    return theme.block.border;
});
var StyledLockedPage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-78185ddd-2"
})(_templateObject2(), COMPUTED_SCREENSHOT_ASPECT_RATIO, function(param) {
    var theme = param.theme;
    return "2px solid ".concat(theme.accent);
}, function(param) {
    var theme = param.theme;
    return theme.accent;
}, function(param) {
    var theme = param.theme;
    return theme.background;
});


/***/ }),

/***/ 5426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageThumbnailTitle; },
/* harmony export */   "k": function() { return /* binding */ StyledPageTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44725);
/* harmony import */ var lodash_truncate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52634);
/* harmony import */ var lodash_truncate__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_truncate__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26235);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40974);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48876);
/* harmony import */ var src_components_UI_ConditionalWrapper_ConditionalWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87760);
/* harmony import */ var src_components_UI_Links__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47209);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  margin-top: 5px;\n  font-family: "IBM Plex Mono";\n  text-align: right;\n  color: ',
        ";\n  word-break: break-word;\n  flex-shrink: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var PageThumbnailTitle = function(param) {
    var plate = param.plate, filterValue = param.filterValue, shouldTruncate = param.shouldTruncate, isPublic = param.isPublic, disableLink = param.disableLink;
    var adjustedPageTitle = function() {
        if (filterValue) {
            return plate.snapshot.title.replace(new RegExp(filterValue, "gi"), function(match) {
                return "<mark>".concat(match, "</mark>");
            });
        }
        if (shouldTruncate) {
            return lodash_truncate__WEBPACK_IMPORTED_MODULE_3___default()(plate.snapshot.title, {
                length: 29
            });
        }
        return plate.snapshot.title;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_ConditionalWrapper_ConditionalWrapper__WEBPACK_IMPORTED_MODULE_6__/* .ConditionalWrapper */ .M, {
        condition: !disableLink,
        wrapper: function(children) {
            return react_device_detect__WEBPACK_IMPORTED_MODULE_5__/* .isElectron */ .d ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_Links__WEBPACK_IMPORTED_MODULE_7__/* .UnstyledLink */ .Ho, {
                href: plate.internalLink,
                children: children
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: plate.internalLink,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    children: children
                })
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPageTitle, {
            $isPublic: isPublic,
            dangerouslySetInnerHTML: {
                __html: adjustedPageTitle()
            }
        })
    });
};
var StyledPageTitle = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c0a3af8e-0"
})(_templateObject(), function(param) {
    var theme = param.theme, $isPublic = param.$isPublic;
    return $isPublic ? theme.text.default : theme.accent;
});


/***/ }),

/***/ 92980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ PostTemplate; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44725);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26235);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_Splash_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45635);
/* harmony import */ var src_components_Splash_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84366);
/* harmony import */ var src_components_Splash_Layout_PageContainer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92377);
/* harmony import */ var src_lib_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30440);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 






function PostTemplate(param) {
    var leftLink = param.leftLink, leftLinkText = param.leftLinkText, rightLink = param.rightLink, rightLinkText = param.rightLinkText, stem = param.stem, stemLink = param.stemLink, pageName = param.pageName, pageNameLink = param.pageNameLink, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Splash_Layout_PageContainer__WEBPACK_IMPORTED_MODULE_5__/* .LDPageContainer */ .R, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Header__WEBPACK_IMPORTED_MODULE_4__/* .LDHeaderWithBreadcrums */ .lY, {
                stem: stem,
                stemLink: stemLink,
                text: pageName || " BLOG",
                textLink: pageNameLink || src_lib_constants__WEBPACK_IMPORTED_MODULE_6__/* .AppRoutes.Blog */ .$w.Blog,
                leftItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: leftLink,
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Header__WEBPACK_IMPORTED_MODULE_4__/* .HeaderLink */ .KS, {
                        style: {
                            textAlign: "left",
                            marginLeft: "20px"
                        },
                        children: leftLinkText
                    })
                }),
                rightItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: rightLink,
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Header__WEBPACK_IMPORTED_MODULE_4__/* .HeaderLink */ .KS, {
                        style: {
                            textAlign: "right",
                            marginLeft: "20px"
                        },
                        children: rightLinkText
                    })
                })
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Footer__WEBPACK_IMPORTED_MODULE_3__/* .LDFooter */ .v, {})
        ]
    });
}


/***/ }),

/***/ 10147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FUNDING_POST_ATTRS": function() { return /* binding */ FUNDING_POST_ATTRS; },
  "default": function() { return /* binding */ FundingPost; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(37296);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(26235);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Splash/Layout/Typography.tsx
var Typography = __webpack_require__(91865);
// EXTERNAL MODULE: ./src/components/Splash/LDBlock.tsx
var LDBlock = __webpack_require__(91881);
// EXTERNAL MODULE: ./src/components/Splash/PostTemplate.tsx
var PostTemplate = __webpack_require__(92980);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
// EXTERNAL MODULE: ./src/app/globalStyles.ts
var globalStyles = __webpack_require__(458);
// EXTERNAL MODULE: ./src/components/Shared/PageThumbnail/PageScreenshot.tsx + 1 modules
var PageScreenshot = __webpack_require__(76468);
// EXTERNAL MODULE: ./src/components/Shared/PageThumbnail/PageThumbnailTitle.tsx
var PageThumbnailTitle = __webpack_require__(5426);
// EXTERNAL MODULE: ./src/components/UI/Links/index.ts
var Links = __webpack_require__(47209);
;// CONCATENATED MODULE: ./src/components/Splash/ViewOnlyPlateThumbnail.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  /* TODO this should extend from previewwrpapper */\n  display: flex;\n  flex-direction: column;\n  user-select: none;\n  cursor: "default";\n  :hover {\n    text-decoration: "default";\n  }\n\n  width: 132px;\n  max-width: 45%;\n  @media (max-width: ',
        ") {\n    width: unset;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.2;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 1rem;\n  margin: 1rem 0;\n  margin-bottom: 20px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var ViewOnlyPlateThumbnail = function(param) {
    var title = param.title, url = param.url, thumbnailUrl = param.thumbnailUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewOnlyPlateThumbnailWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Links/* UnstyledLink */.Ho, {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageScreenshot/* PageScreenshotWrapper */.IM, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageScreenshot/* StyledScreenshotImg */.t9, {
                        isPublic: true,
                        draggable: false,
                        src: thumbnailUrl,
                        plateTitle: title,
                        alt: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewOnlyStyledPageTitle, {
                    $isPublic: true,
                    children: title
                })
            ]
        })
    });
};
var ViewOnlyPlateThumbnailWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-72f633bd-0"
})(_templateObject(), globalStyles/* DEVICE.medium */.T.medium);
var ViewOnlyStyledPageTitle = (0,styled_components_browser_esm/* default */.ZP)(PageThumbnailTitle/* StyledPageTitle */.k).withConfig({
    componentId: "sc-72f633bd-1"
})(_templateObject1());
var ExampleGallery = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-72f633bd-2"
})(_templateObject2());

// EXTERNAL MODULE: ./src/lib/constants.ts
var constants = __webpack_require__(30440);
;// CONCATENATED MODULE: ./src/pages/meta/blog/funding-2022.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 







var FUNDING_POST_ATTRS = {
    title: "VIENNA RAISES CAPITAL",
    SEOtitle: "Vienna Raises Capital",
    date: "September 16, 2022",
    slug: "funding-2022",
    description: "We are pleased to announce that we have raised $2.25m, with participation from existing investors 1517 Fund and Peter Thiel..."
};
var EXAMPLE_PLATES = [
    {
        title: "engineered-eternity",
        url: "https://vienna.earth/plate/saneel/engineered-eternity",
        thumbnailUrl: "https://d1qx4aitdy9duy.cloudfront.net/cccd597a-cdf8-4846-8091-1aa618671c25-light.png"
    },
    {
        title: "Gustav Klimt",
        url: "https://vienna.earth/plate/artvee/Gustav%20Klimt",
        thumbnailUrl: "https://d1qx4aitdy9duy.cloudfront.net/91f7e570-71fc-456d-b3ec-0337cabba76c-light.png"
    },
    {
        title: "reminiscing-our-tomorrow",
        url: "https://vienna.earth/plate/gdbroman/reminiscing-our-tomorrow",
        thumbnailUrl: "https://d1qx4aitdy9duy.cloudfront.net/26aada17-6c4b-4316-ba14-8bd18dc12e87-light.png"
    },
    {
        title: "The Tsar and His Railway",
        url: "https://vienna.earth/plate/nine/The%20Tsar%20and%20the%20Railway",
        thumbnailUrl: "https://d1qx4aitdy9duy.cloudfront.net/29b71f76-ad7d-46a5-8514-c3c7ab339578-light.png"
    }, 
];
function FundingPost() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostTemplate/* PostTemplate */.F, {
        leftLink: constants/* AppRoutes.Meta */.$w.Meta,
        leftLinkText: "HOME",
        rightLink: "",
        rightLinkText: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            FUNDING_POST_ATTRS.SEOtitle,
                            " - Blog - Vienna Hypertext"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: FUNDING_POST_ATTRS.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@vienna_earth"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: FUNDING_POST_ATTRS.SEOtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: FUNDING_POST_ATTRS.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LDBlock/* LDBlock */.zB, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockHeading */.nL, {
                        children: FUNDING_POST_ATTRS.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockDate */.Yf, {
                        children: FUNDING_POST_ATTRS.date
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockParagraph */.yC, {
                        children: "We are pleased to announce that we have raised $2.25m, with participation from existing investors 1517 Fund and Peter Thiel, and new investors FJ Labs, Assembly Capital, Polymath Capital, FAST by GETTYLAB, Dave Petersen, and many others."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* LDBlockParagraph */.yC, {
                        children: [
                            "We will use this opportunity to expand our team and advance toward our vision of",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://vienna.earth/plate/vht/Computer%20Renaissance",
                                children: "digital renaissance"
                            }),
                            ". We are actively hiring. If you have skills and want to grind in SoHo with us, apply",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: constants/* AppRoutes.Jobs */.$w.Jobs,
                                children: "here"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockSubheading */.s1, {
                        children: "The Kritik"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockParagraph */.yC, {
                        children: "In the early days of personal computing, people imagined a future where the computer would be the ultimate tool for human flourishing. Douglas Engelbart, Ted Nelson, Steve Jobs, and other pioneers shared the conviction that great software could unlock some latent potential in man."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* LDBlockParagraph */.yC, {
                        children: [
                            "That is not the world we live in today. If anything our computers and phones have become portals into a homogenous and",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://twitter.com/viennahypertext/status/1511421118489452544",
                                children: "de-energized dystopia"
                            }),
                            ". Despite theoretical access to the most information in history, we are more and more reading the same things, lodging the same complaints, and sharing the same memes."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockParagraph */.yC, {
                        children: "Instead of great tools we got dumb media; instead of digital renaissance we got mediocre cyberpunk."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockSubheading */.s1, {
                        children: "The Plan"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockParagraph */.yC, {
                        children: "Vienna is building a new kind of information network. It will be the digital space where great ideas and projects begin. By combining the ethos of early personal computing with the power of modern communication networks, Vienna will make good on many of the dreams of the ‘60s and ‘70s that fell into obscurity during the gold-rush phase of web2."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockParagraph */.yC, {
                        children: "Here are some examples of what’s being built on the network:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExampleGallery, {
                        children: EXAMPLE_PLATES.map(function(plate) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewOnlyPlateThumbnail, {
                                title: plate.title,
                                url: plate.url,
                                thumbnailUrl: plate.thumbnailUrl
                            }, plate.title);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockParagraph */.yC, {
                        children: "Early Vienna enjoyers have been prolific creators and many have made Vienna their digital home. Both qualitative feedback and measured engagement have been extremely strong. A closed-beta user wrote:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockQuote */.Mo, {
                        children: "> Vienna is fun and pleasing as simple idea expression. I’ve had to set a time limit for my use in my OS settings. I simply love to be here and enjoy the design as a user. A refuge from the rest of the internet."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockParagraph */.yC, {
                        children: "In the near future, we look forward to expanding access to the network."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* LDBlockParagraph */.yC, {
                        children: [
                            "Expect to hear much more from us in the future, including at",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://assembly.urbit.org/",
                                children: "Urbit Assembly"
                            }),
                            ", where we will have a big announcement, later this month."
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);